import Vue from 'vue'
import btnBack from '../components/btnBack'

Vue.component(btnBack.name, btnBack)